var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import call from "../../../call";
import { safeJSONParse } from "../../../utils";
var getStorage = function getStorage(options) {
  call('getTinyLocalStorage', options, {
    modify: {
      success: function success(res) {
        return __assign(__assign({}, res), {
          data: safeJSONParse(res.data, {})
        });
      }
    },
    originOptions: options
  });
};
export default getStorage;